import React from "react";
import {Modal, Button} from "react-bootstrap";

export default function ({show, onHide, id, cancelTicket}) {
    const handleSubmit = () => {
        cancelTicket(id);
    }

    return (
        <>
            <Modal show={show} onHide={onHide} >
                <Modal.Header>
                    <Modal.Title>
                        <span>Bileti ləğv et</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>Bileti ləğv etməyə əminsiniz?</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => onHide(false)}>Geri</Button>
                    <Button onClick={handleSubmit} variant="primary">Təsdiqlə</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}